import React from 'react';
import './button.scss';
import Ripple from '../loader/Ripple.component';

const Button = ({
  onClick,
  active,
  text,
  style,
  iconRight,
  iconLeft,
  padding,
  activeClassName,
  disabled,
  loading,
}) => {
  return (
    <div
      onClick={onClick}
      className={`button button__flex button-text ${
        active ? `button-active ${activeClassName}` : ''
      }`}
      style={{ opacity: disabled ? 0.2 : 1, ...style }}
    >
      {iconLeft}
      <div
        style={{
          marginRight: iconRight && '10px',
          marginLeft: iconLeft && '10px',
          padding,
        }}
      >
        {text}
      </div>
      {iconRight}
      {loading && <Ripple />}
    </div>
  );
};

export default Button;
